import taskInstancesListUrl from './taskInstancesList.html';

class TaskInstancesListCtrl {
  rebuildCounter = 0;

  constructor(PersonaCollection, Utils, ShiftTasksService, sdk) {
    'ngInject';

    Object.assign(this, { PersonaCollection, ShiftTasksService });

    this.buildSections = sdk('helpers/shiftTasks/buildSections');
  }

  $onInit() {
    this.ShiftTasksService.refreshPersonas();
  }

  $onChanges({ groupedInstances }) {
    if (groupedInstances && !groupedInstances.isFirstChange()) {
      this.sections = this.buildSections(
        groupedInstances.currentValue,
        this.groupMethod,
        this.PersonaCollection.personasDict
      );
      this.rebuildCounter++;
    }
  }

  get noSearchResults() {
    const { query, taskInstances, filteredTaskInstances } = this.ShiftTasksService;
    return query && taskInstances.length && !filteredTaskInstances.length;
  }
}

export default {
  templateUrl: taskInstancesListUrl,
  controller: TaskInstancesListCtrl,
  controllerAs: 'ctrl',
  bindings: {
    groupedInstances: '<',
    groupMethod: '<',
    isLoading: '<',
  },
};
